export default "__VITE_ASSET__BFOo4VmV__"